<template>
  <div class="page-info-block">
    <form @submit.prevent="update" @keydown="form.onKeydown($event)">
      <!-- Партнёры -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Партнёры (спонсоры) страницы</label>
        <div class="col-md-7">
          <v-select v-model="form.partners"
                    name="partners"
                    multiple
                    :label="'title'"
                    @input="update"
                    :options="partners"></v-select>
        </div>
      </div>

      <h2 class="page-info-block__title">Стилевое оформление</h2>
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Основной цвет</label>
        <div class="col-md-7">
          <input v-model="form.colors_main" type="text" name="colors_main" class="form-control"
                 placeholder="#3a81c9"
                 :class="{ 'is-invalid': form.errors.has('colors_main') }">
          <has-error :form="form" field="colors_main"></has-error>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Дополнительный цвет</label>
        <div class="col-md-7">
          <input v-model="form.colors_main2" type="text" name="colors_main2" class="form-control"
                 placeholder="#4ad74f"
                 :class="{ 'is-invalid': form.errors.has('colors_main2') }">
          <has-error :form="form" field="colors_main2"></has-error>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Цвет заголовков и полей</label>
        <div class="col-md-7">
          <input v-model="form.colors_text" type="text" name="colors_text" class="form-control"
                 placeholder="#000000"
                 :class="{ 'is-invalid': form.errors.has('colors_text') }">
          <has-error :form="form" field="colors_text"></has-error>
        </div>
      </div>

      <h2 class="page-info-block__title">SEO</h2>
      <!-- SEO title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Заголовок (Title)</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- SEO description -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Описание (Description)</label>
        <div class="col-md-7">
          <textarea v-model="form.description" name="description" class="form-control"
                    :class="{ 'is-invalid': form.errors.has('description') }"></textarea>
          <has-error :form="form" field="description"></has-error>
        </div>
      </div>

      <!-- SEO description -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Ключевые слова (Keywords)</label>
        <div class="col-md-7">
          <textarea v-model="form.keywords" name="keywords" class="form-control"
                    :class="{ 'is-invalid': form.errors.has('keywords') }"></textarea>
          <has-error :form="form" field="keywords"></has-error>
        </div>
      </div>

      <!-- Page background Image -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Фон страницы</label>

        <div class="col-md-3">
          <picture-input
            ref="backgroundPictureInput"
            @change="backgroundImageSelected('background_image')"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn"
            :customStrings="{
                drag: 'Drag an image here'
              }">
          </picture-input>
          <has-error :form="form" field="background_image"></has-error>
        </div>
        <div class="col-md-3"  v-if="form.background_image">
          <img style="max-width:100%;" v-bind:src="'/images/pages/' + pageName + '/' + form.background_image" />
          <button class="btn btn-warning" @click.prevent="removeImage('background_image')">Удалить изображение</button>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-7 col-md-offset-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     name="background_repeat"
                     v-model="form.background_repeat">
              Повторяющийся фон
            </label>
            <has-error :form="form" field="background_repeat"></has-error>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button type="success" :loading="form.busy">Сохранить</v-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from "vue-select";
import {Form} from "vform";
import PictureInput from "vue-picture-input";

export default {
  name: 'PageInfoBlock',
  components: {
    vSelect,
    PictureInput,
  },
  data: () => ({
    form: new Form({
      partners: [],
      title: '',
      colors_main: '',
      colors_main2: '',
      colors_text: '',
      description: '',
      keywords: '',
      background_image: '',
      background_repeat: 0,
    }),
    pageName: ''
  }),
  computed: {
    ...mapGetters({
      partners: 'partners/partners',
      page: 'pages/activePage',
    }),
  },
  methods: {
    async update () {
      const { data } = await this.form.patch('/api/pages/info/' + this.pageName);
      this.$alertify.success(this.$t('admin.global.labels.alert-success'));

      this.$store.dispatch('pages/updatePageInfo', { name: this.pageName, page: data });
    },
    async backgroundImageSelected (field) {
      let res;
      const path = '/api/pages/' + this.pageName + '/images';

      let specialForm = new Form({
        image: this.$refs.backgroundPictureInput.file,
        old_image_name: ''
      });

      if (this.form[field]) {
        specialForm['old_image_name'] = this.form[field];
      }

      const { data } = await specialForm.post(path);
      this.form[field] = data;

      this.update();
    },
    async removeImage (field) {
      const path = '/api/pages/' + this.pageName + '/images';

      let specialForm = new Form({
        image_name: this.form[field]
      });

      await specialForm.delete(path);

      this.form[field] = '';

      this.update();
    },
  },
  updated(){
  },
  mounted() {
    this.pageName = this.$router.currentRoute.path.split('/').filter(p => ['', 'pages', 'admin', 'view', 'edit', 'create'].indexOf(p) === -1).join('_');
    console.log(this.pageName);
    const pageInfo = this.$store.getters['pages/getPageInfo'](this.pageName);
    console.log(pageInfo);
    if (pageInfo && pageInfo.partners) {
      this.form.partners = pageInfo.partners;
      this.form.title = pageInfo.title;
      this.form.colors_main = pageInfo.colors_main;
      this.form.colors_main2 = pageInfo.colors_main2;
      this.form.colors_text = pageInfo.colors_text;
      this.form.description = pageInfo.description;
      this.form.keywords = pageInfo.keywords;
      this.form.background_image = pageInfo.background_image;
      this.form.background_repeat = pageInfo.background_repeat;
    }
  },
  beforeMount () {
    this.$store.dispatch('partners/fetchPartners');
  }
}
</script>
